export default "__VITE_ASSET__Cig7UzmQ__"